import Announcement from "../components/PopupComponents/Announcement";
import { useAuth } from "./useAuth";
import { usePopupContext } from "./PopupContext";
import useApiWrapper from "../services/api/apiWrapper";
import { useMixPanel } from "./useMixPanel";

/**
 * Common logic for the feedback components, both for modal and card
 * @param {*} props 
 */
const usePopup = () => {
  // Dismiss all popups
  const { userInfo, setAndStoreUserInfo } = useAuth()
  const { popupAndCardState, setPopupAndCardState, isApiCallInProgressRef } = usePopupContext()
  const api = useApiWrapper()
  const { logEvent } = useMixPanel()

  const handleDismissPopup = async () => {
    isApiCallInProgressRef.current = true
    const popupAttributes = userInfo?.customAttributes?.popup
    const payload = []
    const eventsData = popupAndCardState.popupData

    // If there are no popup attributes, build the payload using
    // the popup data from launchdarkly
    if (!popupAttributes) {
      payload.push(...eventsData.filter(item => item.targetCountries.includes(userInfo.countryCode)).map(popup => ({
        popupId: popup.contentId,
        isClosed: false,
        isCardForm: true
      })))
    } else {
      // If there are popup attributes, find all popup that is not a card
      // or from the launchdarkly popup data, include it in the payload
      const popupDataKeys = eventsData.filter(item => item.targetCountries.includes(userInfo.countryCode)).map(popup => popup.contentId)
      popupDataKeys.forEach(key => {
        if (!(key in popupAttributes)) {
          payload.push({
            popupId: key,
            isClosed: false,
            isCardForm: true
          })
        }
      })
    }

    setPopupAndCardState(prev => ({
      ...prev,
      popupData: eventsData.map(item => ({
        ...item,
        isClosed: popupAttributes?.[item.contentId]?.isClosed || false,
        isCardForm: true
      })),
      shouldShowPopup: false
    }))

    if (payload.length > 0) {
      await api.put(`${process.env.REACT_APP_OFFICE_BE_PH_URL}/v1/user/${userInfo?.unicityId}/dismiss-popup`,
        payload,
        {
          addPrefix: false,
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        }
      )
    }
    const dismissedPopupIds = eventsData
      .filter(item => !item.isClosed && (!item.isCardForm && !item.isCardByDefault))
      .map(item => item.contentId)

    logEvent('popup_dismissed', {
      unicity_id: userInfo?.unicityId,
      country_code: userInfo?.countryCode,
      popup_content_id: dismissedPopupIds.join(','),
    })

    const userInfoPopupAttributes = userInfo?.customAttributes?.popup || {}
    const updatedValues = {
      ...userInfoPopupAttributes,
    }
    payload.forEach(item => {
      updatedValues[item.popupId] = {
        isCardForm: true,
        isClosed: false,
      }
    })
    setAndStoreUserInfo({
      ...userInfo,
      customAttributes: {
        ...userInfo?.customAttributes,
        popup: updatedValues,
      }
    })
    isApiCallInProgressRef.current = false
  }

  const renderPopupContent = (item, handlePopupAttributeChange) => {
    if (!item) return null;

    switch (item.type) {
      case "survey":
        return <p style={{ color: "red" }}>Survey</p>
      case "announcement":
        return <Announcement data={item} handlePopupAttributeChange={handlePopupAttributeChange} />
      default:
        return <p>Unsupported content type</p>
    }
  }

  return {
    renderPopupContent,
    handleDismissPopup
  }
}

export default usePopup;
